/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseStrData } from './genericApiResponseStrData';
import type { GenericApiResponseStrMessage } from './genericApiResponseStrMessage';
import type { GenericApiResponseStrPagination } from './genericApiResponseStrPagination';
import type { GenericApiResponseStrError } from './genericApiResponseStrError';

export interface GenericApiResponseStr {
  data?: GenericApiResponseStrData;
  message?: GenericApiResponseStrMessage;
  pagination?: GenericApiResponseStrPagination;
  error?: GenericApiResponseStrError;
  statusCode?: number;
}
